import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  slider: {
    padding: 0,
    height: 6,
    color: theme.palette.primary.main,
    zIndex: 10,
    "& .MuiSlider-rail": {
      height: 6,
      backgroundColor: theme.props.text.alt + "33",
    },
    "& .MuiSlider-track": {
      height: 6,
    },
    "& .MuiSlider-thumb": {
      background: "linear-gradient(180deg, #F5F6FA 30.21%, #FFFFFF 100%)",
      border: "2px solid #fff",
      boxSizing: "border-box",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
      height: 16,
      width: 16,
    },
  },
  inactivityContainer: {
    width: "100%",
    position: "relative",
    height: 6,
    top: -6,
  },
  inactivityBlock: {
    position: "absolute",
    height: "100%",
    backgroundColor: theme.props.text.alt,
    opacity: .2,
    top: 0,
    display: "block",
  }
}));

export default useStyle;